import type { ReactNode } from 'react';
import type { ChartRendererProps } from '@/chart/types';
import type { ChartData } from '@/chart-data/types';
import type { ChartType } from '@/types';

export type CustomChartRenderer = {
  chartType: ChartType;
  hasNoResults?: (chartData: ChartData) => boolean;
  canRender: (props: ChartRendererProps) => boolean;
  render: (props: ChartRendererProps) => ReactNode;
};

const customChartRenderers = new Map<ChartType, CustomChartRenderer>();

export const registerCustomChartRenderer = (renderer: CustomChartRenderer) => {
  customChartRenderers.set(renderer.chartType, renderer);
};

export const getCustomChartRenderer = (chartType: ChartType) => {
  return customChartRenderers.get(chartType);
};

export const clearCustomChartRenderers = () => {
  customChartRenderers.clear();
};

